<template>
  <v-app>
    <AppToolbar></AppToolbar>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import AppToolbar from "./components/AppToolbar.vue";

</script>

<style>
@import "@/assets/scss/main.scss";
</style>
